import {
    DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_REQUEST,
    DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_SUCCESS,
    DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_FAILURE,
    DELIVERY_CHALLAN_REGISTER_RETURN_YARN_FILTER_REPORT_REQUEST,
    DELIVERY_CHALLAN_REGISTER_RETURN_YARN_FILTER_REPORT_SUCCESS,
    DELIVERY_CHALLAN_REGISTER_RETURN_YARN_FILTER_REPORT_FAILURE
  } from "../types/delivery-challan-register-return-yarn-report-types";
  
  const initialState = {
    deliveryChallanReturnYarnReports: {},
    loading: false,
    error: null,
  };
  
  const deliveryChallanReturnYarnReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_REQUEST: 
      case DELIVERY_CHALLAN_REGISTER_RETURN_YARN_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_SUCCESS: {
        return {
          ...state,
          deliveryChallanRegisterReturnYarnReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case DELIVERY_CHALLAN_REGISTER_RETURN_YARN_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          deliveryChallanRegisterReturnYarnFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT_FAILURE: 
      case DELIVERY_CHALLAN_REGISTER_RETURN_YARN_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default deliveryChallanReturnYarnReportReducer;
  